import { Component } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { DocumentsBase } from '@zero/instrument-details/feature-instrument-details/base';

@Component({
  selector: 'instrument-details-instrument-documents',
  templateUrl: './documents-web.component.html',
  imports: [TranslocoPipe],
})
export class DocumentsWebComponent extends DocumentsBase {}
